import { useState, useEffect } from 'react';

/**
 * A custom hook that listens for a specific keyboard sequence ("cockpit").
 * When the sequence is detected, it returns true.
 * This can be used to reveal hidden features or menus (easter egg).
 *
 * @returns {boolean} - True if the sequence has been successfully typed, false otherwise.
 */
export const useDisplayHiddenMenu = (): boolean => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [keySequence, setKeySequence] = useState<string>('');

    const targetSequence = 'cockpit';

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (showMenu) return;

            const newSequence = (keySequence + event.key).slice(-targetSequence.length);
            setKeySequence(newSequence);

            if (newSequence === targetSequence) {
                setShowMenu(true);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [keySequence, showMenu]);

    return showMenu;
};

export default useDisplayHiddenMenu;
